import { checkGate, getLayer } from '@eventbrite/statsig';
import {
    ALWAYS_ENABLE_TICKETS_PAGE_BUTTON_LAYER_EXPERIMENT,
    APPLE_PAY_ON_LISTINGS_PAGE_EXPERIMENT,
    COPY_INFORMATION_CHECKBOX_ORDER_FORM_EXPERIMENT,
    EXPRESS_PAYPAL_ON_TICKET_SELECTION_PAGE_EXPERIMENT,
    PlaceOrderAndTosVariant,
    RemainingTicketsFormat,
    REMAINING_TICKETS_FORMAT_SELECTION_PAGE_EXPERIMENT,
    SCROLLABLE_CTA_ON_TICKET_SELECTION_PAGE_EXPERIMENT,
    SCROLLABLE_CTA_TOS_ON_ORDER_FORM_EXPERIMENT,
    SHORT_TOS_TEXT_ORDER_FORM_EXPERIMENT,
    TicketsPageButtonEnabledCriteria,
    URGENCY_SIGNALS_ON_TICKET_SELECTION_PAGE_EXPERIMENT,
} from '../constants/statsig';

export const getAlwaysEnableTicketsPageButtonExperimentVariant = () =>
    getLayer<
        TicketsPageButtonEnabledCriteria,
        TicketsPageButtonEnabledCriteria
    >(
        ALWAYS_ENABLE_TICKETS_PAGE_BUTTON_LAYER_EXPERIMENT.layer,
        ALWAYS_ENABLE_TICKETS_PAGE_BUTTON_LAYER_EXPERIMENT.param,
        ALWAYS_ENABLE_TICKETS_PAGE_BUTTON_LAYER_EXPERIMENT.defaultValue,
    );

export const checkDisplayDonationCardFeatureGate = () =>
    checkGate('checkout_display_donation_card');

export const isUrgencySignalsExperimentEnabled = () => {
    const value = getLayer(
        URGENCY_SIGNALS_ON_TICKET_SELECTION_PAGE_EXPERIMENT.layer,
        URGENCY_SIGNALS_ON_TICKET_SELECTION_PAGE_EXPERIMENT.param,
        URGENCY_SIGNALS_ON_TICKET_SELECTION_PAGE_EXPERIMENT.defaultValue,
    );

    return value === true || value === 'true';
};

export const isScrollableCtaExperimentEnabled = () => {
    const value = getLayer(
        SCROLLABLE_CTA_ON_TICKET_SELECTION_PAGE_EXPERIMENT.layer,
        SCROLLABLE_CTA_ON_TICKET_SELECTION_PAGE_EXPERIMENT.param,
        SCROLLABLE_CTA_ON_TICKET_SELECTION_PAGE_EXPERIMENT.defaultValue,
    );
    return value === true || value === 'true';
};

export const isApplePayOnListingsExperimentEnabled = () => {
    const value = getLayer(
        APPLE_PAY_ON_LISTINGS_PAGE_EXPERIMENT.layer,
        APPLE_PAY_ON_LISTINGS_PAGE_EXPERIMENT.param,
        APPLE_PAY_ON_LISTINGS_PAGE_EXPERIMENT.defaultValue,
    );
    return value === true || value === 'true';
};

export const isExpressPaypalExperimentEnabled = () => {
    const value = getLayer(
        EXPRESS_PAYPAL_ON_TICKET_SELECTION_PAGE_EXPERIMENT.layer,
        EXPRESS_PAYPAL_ON_TICKET_SELECTION_PAGE_EXPERIMENT.param,
        EXPRESS_PAYPAL_ON_TICKET_SELECTION_PAGE_EXPERIMENT.defaultValue,
    );
    return value === true || value === 'true';
};

export const getRemainingTicketsFormatExperimentValue = () => {
    const { layer, param, defaultValue } =
        REMAINING_TICKETS_FORMAT_SELECTION_PAGE_EXPERIMENT;
    return getLayer<RemainingTicketsFormat, RemainingTicketsFormat>(
        layer,
        param,
        defaultValue,
    );
};

export const getCopyInformationCheckboxExperimentValue = () => {
    const { layer, param, defaultValue } =
        COPY_INFORMATION_CHECKBOX_ORDER_FORM_EXPERIMENT;
    const value = getLayer(layer, param, defaultValue);
    return value === true || value === 'true';
};

export const getShortToSTextExperimentValue = () => {
    const { layer, param, defaultValue } = SHORT_TOS_TEXT_ORDER_FORM_EXPERIMENT;
    const value = getLayer(layer, param, defaultValue);
    return value === true || value === 'true';
};

export const getScrollablePlaceOrdeCtaTosValue = () => {
    const { layer, param, defaultValue } =
        SCROLLABLE_CTA_TOS_ON_ORDER_FORM_EXPERIMENT;
    return getLayer<PlaceOrderAndTosVariant, PlaceOrderAndTosVariant>(
        layer,
        param,
        defaultValue,
    );
};
